<template>
  <div class="row">
    <div class="col-12">
      <card>
        <vue-element-loading
          :text="loading.text"
          spinner="bar-fade-scale"
          :color="loading.color"
          :active="loading.active"
          :is-full-screen="false"/>
        <div>
          <div class="col-sm-12 card">
            <el-table stripe
                      style="width: 100%;"
                      :data="tableData"
                      size="mini">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="text-right">
          <downloadexcel :fetch="generateExcel" :fields="tableExcel"
                         :before-generate="startDownload"
                         :before-finish="finishDownload"
                         type="csv"
                         class="btn btn-filmker-pink btn-fill btn-sm">
            Descargar
          </downloadexcel>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {Dialog, Option, Select, Table, TableColumn} from 'element-ui'
  import {Pagination as LPagination} from 'src/components/index'
  import vueElementLoading from 'vue-element-loading'
  import downloadexcel from "vue-json-excel";

  export default {
    components: {
      LPagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      vueElementLoading,
      [Dialog.name]: Dialog,
      downloadexcel
    },
    data() {
      return {
        dataFor: [],
        users: [],
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        contacts: [],
        change: false,
        searchQuery: '',
        propsToSearch: ['email'],
        tableExcel: {
          'Dominio': 'domain',
          'IP': 'request_ip',
          'Proxy': 'request_ip_proxy',
          'Fecha': 'created_at',
          'Respuesta': 'response',
        },
        tableColumns: [
          {
            prop: 'domain',
            label: 'Dominio',
          },
          {
            prop: 'request_ip',
            label: 'IP',
          },
          {
            prop: 'request_ip_proxy',
            label: 'Proxy',
          },
          {
            prop: 'created_at',
            label: 'Fecha',
          },
          {
            prop: 'response',
            label: 'Respuesta',
          },
        ],
        tableData: [],
        account: {},
        modelValidations: {
          name: {
            required: true
          },
          country: {
            required: true,
          }
        }
      }
    },
    methods: {
      changePage() {
        this.loadUsers()
      },
      loadUsers() {
        this.loading.active = true
        this.axios({
          url: `conexions.php?datos=5`,
          method: 'get',
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.tableData = response.data.message
            this.dataFor = response.data.message
          })
          .catch(error => {
            this.loading.active = false
          })
      },
      generateExcel() {
        return this.tableData
      },
      handleDelete(id) {
        this.loading.active = true
        this.axios({
          url: `conexions.php?license=${id}`,
          method: 'delete',
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.loadUsers()
            swal({
              title: 'Deleted!',
              text: response.message,
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
          .catch(error => {
            this.loading.active = false
            swal({
              title: 'Deleted!',
              text: error.response.message,
              type: 'error',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
      },
      startDownload() {
        this.showSwal('success', 'Iniciando Descarga')
      },
      finishDownload() {
        this.showSwal('success', 'Descarga Completada')
      },
      showSwal(type, id) {
        if (type === 'success') {
          swal.fire({
            title: id,
            type: 'success'
          })
        } else if (type === 'delete') {
          swal({
            title: '¿Esta seguro?',
            text: `Esta operación no puede ser revertida!`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Eliminar',
            buttonsStyling: false
          }).then((action) => {
            if (action.value) {
              this.handleDelete(id)
            }
          })
        }
      },
    },
    created() {
      this.loadUsers(1)
    },
    mounted() {
    },
    watch: {
      searchQuery(value) {
        this.loadUsers(1)
      }
    }
  }
</script>
<style>
</style>
